import { useEffect } from "react";
import { baseEramHubConnection } from "../../eramHubConnectionFactory.js";
import { isControllerRole } from "@poscon/shared-types/poscon";
const autoSigninArtccId = import.meta.env.VITE_AUTO_SIGNIN_ARTCC_ID;
const autoSigninPosition = import.meta.env.VITE_AUTO_SIGNIN_POSITION;
export const useAutoSignin = (client, initializeConnection) => {
    useEffect(() => {
        const login = async (...args) => {
            if (baseEramHubConnection.sectorId === null) {
                await initializeConnection(...args);
                await baseEramHubConnection.connect();
                if (import.meta.env.DEV && isControllerRole(args[2])) {
                    setTimeout(() => baseEramHubConnection.signin(client), 1000);
                }
            }
        };
        const urlParams = new URLSearchParams(window.location.search);
        const urlArtccId = urlParams.get("artccId");
        const urlSectorId = urlParams.get("sectorId");
        const role = urlParams.get("role") ?? "Radar";
        const sectorId = urlSectorId ?? autoSigninPosition;
        const artccId = urlArtccId ?? autoSigninArtccId;
        if (sectorId || artccId) {
            void login((artccId ?? sectorId.split(".")[0]), sectorId ?? null, role);
        }
    }, [initializeConnection, client]);
};
//# sourceMappingURL=useAutoSignin.js.map